<ng-container *ngIf="isNotCompany$ | async">
  <h2>Способ оплаты</h2>
  <ng-container *ngIf="paymentModes$ | async as paymentModes">
    <sd-prepayment *ngIf="paymentModes.length > 0"></sd-prepayment>

    <ng-container
      *ngIf="{
        mode: activeMode$ | async,
        bankCard: activeBankCard$ | async,
        activeModeId: activeModeId$ | async,
      } as active"
    >
      <ng-container>
        <sd-checkout-payment-choose-list></sd-checkout-payment-choose-list>
      </ng-container>

      <div *ngIf="validationErrors$ | async as errors">
        <div *ngFor="let err of errors" class="error-msg alert-danger" role="alert">
          {{ errors }}
        </div>
      </div>

      <ng-container *ngIf="{ showManagerWillCall: showManagerWillCall$ | async } as obs">
        <div *ngIf="obs.showManagerWillCall || paymentModes.length === 0" class="manager-call">
          Менеджер уточнит условия оплаты после оформления заказа
        </div>
      </ng-container>

      <ng-container *ngIf="active.mode">
        <div
          class="payment-later-toggler"
          *ngIf="
            active.bankCard &&
            active.mode.code === PaymentModeCodes.Sbrf &&
            active.mode.hasBindings &&
            (paymentNowEnable$ | async)
          "
        ></div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
